/* eslint-disable import/prefer-default-export */
import { endpoints } from '@source/config';

export const HOME_PLAYLIST_ENDPOINT = `${endpoints.api}/videos/playlists`;

export const BANNER_ENDPOINT = `${endpoints.api}/campaigns/banner-positions`;

export const HISTORY_ENDPOINT = `${endpoints.api}/userdata`;

export const SEARCH_ENDPOINT = `${endpoints.api}/search/`;
export const SEARCH_GENRE_ENDPOINT = `${endpoints.api}/videos/playlists/genre`;
export const RECENT_SEARCH_ENDPOINT = `${SEARCH_ENDPOINT}histories`;

export const VIDEO_DETAIL_ENDPOINT = `${endpoints.api}/videos`;
export const ADD_DEVICE_ENDPOINT = `${endpoints.api}/videos/drm/add-device`;
// export const MOVIE_STREAMING = `${endpoints.api}/videos`;
export const PROGRAMME_GUIDES = `${endpoints.api}/videos/program-guides`;
export const ARTICLES_ENDPOINT = `${endpoints.api}/articles/articles`;
export const ARTICLES_RECOMMENDED_ENDPOINT = `${endpoints.api}/articles/lists`;
export const ARTICLES_RELATED_ENDPOINT = `${endpoints.api}/articles/related`;
